import { SvgInjector } from './modules/svgInjector';
import { Parallax } from './modules/parallax';
import { ImagePopUp } from './modules/imagePopUp';
import { Carousels } from './modules/carousels';
import { MiniGallery } from './modules/miniGallery';
import { Cookies } from './modules/cookies';
import { ScrollTo } from './modules/scrollTo';
import { GoogleMaps } from './modules/googleMaps';
import { Video } from './modules/video';
import { Validator } from './modules/validator';
import { SidePanel } from './modules/sidePanel';
// import {Load}             from './modules/load';
import { Visible } from './modules/visible';

var svgInjector = new SvgInjector();
var parallax = new Parallax();
var imagePopUp = new ImagePopUp();
var carousels = new Carousels();
var miniGallery = new MiniGallery();
var cookies = new Cookies();
var scrollTo = new ScrollTo();
var googleMaps = new GoogleMaps();
var video = new Video();
var validator = new Validator();
var sidePanel = new SidePanel();
// var load              = new Load();
var visible = new Visible();

class Main {
    constructor(node_env) {
        this.node_env = node_env;
        this.sections = $('.cms-section');
    }
    bootstrap(callback) {
        var $sections = $(this.sections);
        this.modules($sections);
        this.responsiveModules($sections);
        callback();
    }

    modules($sections) {
        parallax.init($sections);
        svgInjector.init();
        imagePopUp.init();
        carousels.init();
        miniGallery.init();
        cookies.init();
        scrollTo.init();
        googleMaps.init();
        video.init();
        validator.init();
        sidePanel.init();
        // load.init();
        visible.init();
    }

    responsiveModules($sections) {
        $(window).resize(function() {
            parallax.init($sections);
            carousels.init();
            miniGallery.init();
        });

        $(window).scroll(function() {
            $('.video-player').each(function(id, videoPlayer) {
                if ($(videoPlayer).visible(true)) {
                    video.play($(videoPlayer));
                } else {
                    video.stop($(videoPlayer));
                }
            });
        });
    }
}


$(window).load(function() {
    var main = new Main('development');
    main.bootstrap(function() {
        $('#page-overlay').fadeOut(800);
    });
});

$(document).ready(function() {

    $('body').on('click', ".form_with_products button.add_product", function(event) {
        event.preventDefault();
        event.stopPropagation();
        var form = $(this).closest('form.form_with_products');
        var products_wrapper = form.find("div.products-wrapper");
        var last_product = products_wrapper.find("div.product-row").last();
        var product_nbr = last_product.attr('data-product');
        product_nbr = product_nbr !== undefined ? product_nbr : 0;
        var next_product = parseInt(product_nbr) + 1;
        var template = `<div class='form-group col-12 product-row' data-product='` + next_product + `'>
                          <div class='row pr-5'>
                              <div class='col-2 col-md-1 d-flex align-items-center mb-3'>
                                  <span class='lp'>` + next_product + `</span>
                              </div>
                              <div class='col-10 col-md-8 mb-3'>
                                  <input type='text' class='w-100 p-2' name='products[` + next_product + `][name]' placeholder='Nazwa towaru' required/>
                              </div>
                              <div class='col-10 offset-2 col-md-3 offset-md-0 mb-3'>
                                  <input type='number' class='w-100 p-2' name='products[` + next_product + `][quantity]' min='0' placeholder='Ilość' required/>
                              </div>
                              <div class='col-10 offset-2 col-md-11 offset-md-1 mb-3'>
                                  <input type='text' class='w-100 p-2'name='products[` + next_product + `][document]'  placeholder='Numer dokumentu zakupu' required/>
                              </div>
                              <button class="delete_row">
                                <i class="fa fa-times-circle"></i>
                              </button>
                          </div>
                        </div>`;
        products_wrapper.append(template);
    });

    $('body').on('click', ".form_with_products .product-row button.delete_row", function() {
        var confirmed = confirm("Czy chcesz usunąć ten produkt ?");
        if (confirmed) {
            var row = $(this).closest('.product-row');
            row.remove();
            setTimeout(function() {
                $(".form_with_products .product-row").each(function(index) {
                    var i = index + 1;
                    $(this).attr('data-product', i);
                    $(this).find('.lp').html(i);
                });
            }, 150)
        }
    })
});